

export interface IMapFieldsState{
  typeStoreFields: string,
  fields: any[],
  dynamic: any[],
  
  optionsFields: any,
  errorFields: string,
  isLoadingFields: boolean,
  isFetchDataFields: boolean,
  isFetchDynamicFields: boolean
}

export enum MapFieldsActionEnum {
  FETCH_DATA_FIELDS = "FETCH_DATA_FIELDS",
  FETCH_DYNAMIC_DATA_FIELD = "FETCH_DYNAMIC_DATA_FIELD",
  IS_LOADING_FIELDS = "IS_LOADING_FIELDS",
  GET_ERROR_FIELDS = "GET_ERROR_FIELDS",
  SELECT_FIELD = "SELECT_FIELD",
  FETCH_FIELDS_TYPE = "FETCH_FIELDS_TYPE",
}

interface IFetchDataFieldsAction {
  type: MapFieldsActionEnum.FETCH_DATA_FIELDS;
  payload: any
}

interface IFetchFieldsTypeAction {
  type: MapFieldsActionEnum.FETCH_FIELDS_TYPE;
  payload: any
}

interface IFetchDynamicDataFieldsAction {
  type: MapFieldsActionEnum.FETCH_DYNAMIC_DATA_FIELD;
  payload: any
}

interface IsLoadingFieldsAction {
  type: MapFieldsActionEnum.IS_LOADING_FIELDS;
  payload: any
}

interface ErrorsFieldsAction {
  type: MapFieldsActionEnum.GET_ERROR_FIELDS;
  payload: any
}

export type IMapFieldsAction =
  IFetchDataFieldsAction |
  IFetchDynamicDataFieldsAction |
  IsLoadingFieldsAction |
  ErrorsFieldsAction |
  IFetchFieldsTypeAction